import React, {Fragment, useState} from 'react';

const SelectSendStatus = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {

  const [sendStatus, setSendStatus] = useState([
    {label: "آماده سازی", value: "inProcess"},
    {label: "توسط پیک", value: "courier"},
    {label: "تحویل شده", value: "delivered"},
  ])

  return (
    <div>

      <div className="divgroup">
        <label htmlFor="sendData__serviceTitle">وضعیت ارسال</label>
        <div className="form-control">
          <div className={'d-flex p-1'} style={{fontSize: 10,fontWeight:'normal'}}>
            {sendStatus.map((object, index) => <Fragment key={index}>
              <div style={{fontSize: 12,fontWeight:'normal'}} onClick={(e) => {
                e.preventDefault();
                setSendData({sendStatus: object.value})
              }}
                   className={sendData.sendStatus===object.value ? "border border-info btn btn-success" : "border border-success btn"}
              >{object.label}</div>
            </Fragment>)}
          </div>


        </div>
      </div>
    </div>
  );
};

export default SelectSendStatus;
